import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-design',
  templateUrl: './logo-design.component.html',
  styleUrls: ['./logo-design.component.scss']
})
export class LogoDesignComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
